const langtrans={
      bjjjyg:["报价已关闭"," Quotation has been closed"],
      qssjj:["起始时间","Start time"],
      jjssjj:["结束时间不能早于起始时间","Finish time cannot be earlier than the start time"],
      jjss:["结束时间","End time"],
      ajbh:["案件编号","Case number"],
      czx:["查询","Check"],
      zwmsss:["暂无数据","Data is temporary not available"],
      xhh:["序号","Serial no."],
      ajbhh:["案件编号","Case no."],
      ffsddd:["发生地点","Case location"],
      yhxm:["用户姓名","User name"],
      yhsjhh:["用户手机号","Mobile no."],
      zjxsxx:["证件信息","ID information"],
      xbb:["性别","Gender"],
      cxsjj:["出险时间","Time of claim"],
      yhbxxq:["用户保险详情","Policy details"],
      bxxqq:["保险详情","Policy details"],
      wm:["无","None"],
      ddqjdd:["当前进度","Current progress"],
      ddqjjd:["当前节点","Current node"],
      hfsjj:["回复时间","Time of reply"],
      cczzz:["操作","Operating Party"],
      czkkxq:["查看详情","en_translated"],
      qqlll:["请求了","en_translated"],
      n:["男","male"],
      nr:["女","female"],
      zzzhzz:["指挥中心关闭报价","Command center closing quotation"],
      czkkbb:["查看并操作","Check and process"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/components/fac/js/close.vue.trans.js